import React, { Component } from 'react'
import { Button, Input, Alert, } from 'reactstrap'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'

class HtmlEditor extends Component {
  state = {
    contents: this.props.contents + '',
    changed: false,
    saved: false,
    saving: false,
    error: '',
  }

  componentWillUnmount() {
    this.saveContents('unmounting')
  }

  saveContents = (unmounting) => {
    const { contents } = this.state
    const { save }  = this.props
    this.setState({saving: true})
    save(contents)
      .then(() => {
       
        if (!unmounting) {
         
          return this.setState({
            changed: false, 
            saved: true, 
            error: '', 
            saving: false
          })
        }
      })
      .catch((error) => {
       
        return (unmounting || this.setState({error, saving: false}))
      })
  }

  handleChange = ({target}) => this.setState({
    [target.name]: target.value,
    saved: false,
    changed: true,
    error: '',
  })

  render() {
    const { contents, error, saving, saved } = this.state
    const { closeEditor, loading, contentType } = this.props
    const { saveContents, handleChange } = this
    return (
      <div>
        {!loading && 
          <Input
            type='textarea'
            name='contents'
            value={contents}
            onChange={handleChange}
            rows={contentType === 'passage' ? '25' : '6'}
          />
        }
        <BeatLoader loading={loading} />
        <Button 
          disabled={!!saved || !!saving} 
          onClick={() => saveContents(false)}
        >
          {!saving && (!saved ? 'Save Changes' : 'Saved')}
          <BeatLoader loading={saving} />
        </Button>
        <Button onClick={closeEditor}>
          Preview
        </Button>
        {error && <Alert>{error}</Alert>}
      </div>
    )
  }
}

HtmlEditor.propTypes = {
  closeEditor: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  contents: PropTypes.string,
  loading: PropTypes.bool,
  contentType: PropTypes.string.isRequired,
}

HtmlEditor.defaultProps = {
  contents: ''
}

export default HtmlEditor


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/HtmlEditor.js